<div
	class="grid grid-rows-[min-content_1fr] grid-cols-1 gap-4 overflow-hidden h-full w-full"
>
	<div class="flex items-center">
		<atomic-message-bar *ngIf="_selectedPin?.sameAdjacentOwners" type="warn"
			>Similar Names have been detected on respective transfer instruments of
			the primary and adjacent parcels.</atomic-message-bar
		>
		<div
			class="flex flex-1"
			[ngClass]="{ 'justify-end': _selectedPin?.sameAdjacentOwners }"
		>
			<app-checkbox [(ngModel)]="showOnlySimilar" type="clear"
				>Show only similar names</app-checkbox
			>
		</div>
	</div>

	<div class="grid grid-rows-1 grid-cols-2 gap-4 h-full overflow-hidden">
		<div class="overflow-y-auto h-full rounded">
			<app-parcel-name-compare
				[Pin]="_selectedPin?.pin"
				[primary]="true"
			></app-parcel-name-compare>
		</div>
		<div class="overflow-y-auto h-full rounded" *ngIf="_selectedPin?.map">
			<app-parcel-name-compare
				class="mb-5"
				*ngFor="let pin of _selectedPin?.map?.adjacent_parcels"
				[Pin]="pin.pin"
				[showSimilar]="showOnlySimilar"
			></app-parcel-name-compare>
		</div>
	</div>
</div>
